const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/raw-footage/mcap-segments/$assetId/$segmentId.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/raw-footage/mcap-segments/$assetId/$segmentId.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { McapSegmentPageSkeleton } from '@/features/mcap/components/McapSegmentPageSkeleton';
import { logicalSegmentQueryOptions } from '@/features/mcap/services/segmentQueries';
import { createDeliveryInputSchema } from '@/features/mcap/types/contracts';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const mcapSegmentSearchSchema = z.object({
  retryDeliveryId: createDeliveryInputSchema.shape.deliveryId.optional().catch(undefined),
  retryIncludeHandpose: z.boolean().optional().catch(undefined)
});
export const Route = createFileRoute('/_authenticated/_app/raw-footage/mcap-segments/$assetId/$segmentId')({
  beforeLoad: requireCapabilities(has => has('mcaps.read')),
  validateSearch: mcapSegmentSearchSchema,
  // Prefetch the logical segment so this route owns the loading skeleton
  // (`pendingComponent`) and initial-fetch error UI (`errorComponent`); the page
  // reads from the warm cache.
  loader: ({
    context,
    params
  }) => context.queryClient.ensureQueryData(logicalSegmentQueryOptions(params.assetId, params.segmentId)),
  pendingComponent: () => <div className="flex flex-1 flex-col p-6">
      <McapSegmentPageSkeleton />
    </div>,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});